import MathMLFormula from './MathMLFormula';

export default MathMLFormula;
